<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="loading">
      <span class="loader"></span>
    </span>
    <div v-if="property && !loading" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
        v-model="activeTab"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <property-view-global v-if="activeTab === '1'" :property="property" @propertyUpdated="get"
            @onCommentCreated="commentCreated" :key="componentKey" @onExtractDetails="extractPropertyDetails" />
        </tab-pane>
        <tab-pane title="global" id="2">
          <span slot="title">
            <i class="ni ni-circle-08"></i>
            {{ $t("COMMON.OWNERS") }}
          </span>
          <property-contact-list-table
            v-if="alreadyLoadedTabs.includes('2')"
            v-show="activeTab === '2'"
            :property="property"
            :filterProperty="property?.id"
          />
        </tab-pane>
        <tab-pane title="global" id="3">
          <span slot="title">
            <i class="ni ni-circle-08"></i>
            {{ $t("COMMON.COMMUNICATIONS") }}
          </span>
          <property-communication-list-table
            v-if="alreadyLoadedTabs.includes('3')"
            v-show="activeTab === '3'"
            :property="property"
            :filterProperty="property?.id"
            @onCommunicationCreated="communicationCreated"
            :key="componentKey"
          />
        </tab-pane>
        <tab-pane
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_TRANSACTIONS_PROPERTIES)
          "
          title="global"
          id="4"
        >
          <span slot="title">
            <i class="fas fa-money-bill"></i>
            {{ $t("COMMON.PAYMENTS") }}
          </span>
          <payment-list-table
            v-if="alreadyLoadedTabs.includes('4')"
            v-show="activeTab === '4'"
            :refreshView="get"
            :property="property"
            :filterProperty="property?.id"
            @onTransactionAdded="transactionAdded"
            :key="componentKey"
          />
        </tab-pane>
        <tab-pane title="global" id="5">
          <span slot="title">
            <i class="ni ni-money-coins"></i>
            {{ $t("PROPERTIES.APPLICABLES_FEES") }}
          </span>
          <property-applicables-fees-list-table
            v-if="alreadyLoadedTabs.includes('5')"
            v-show="activeTab === '5'"
            :property="property"
            @onPropertyFeesUpdated="propertyFeeUpdated"
            :filterProperty="property?.id"
            :key="componentKey"
          />
        </tab-pane>

        <!-- <tab-pane title="global" id="4">
          <span slot="title">
            <i class="ni ni-money-coins"></i>
            {{ $t("COMMON.BIDS") }}
          </span>
          <property-view-bids :property="property" />
        </tab-pane> -->

        <tab-pane
          title="files"
          id="6"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component  v-if="alreadyLoadedTabs.includes('6')"
            v-show="activeTab === '6'":object="property" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="7"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <property-view-logs v-if="alreadyLoadedTabs.includes('7')"
            v-show="activeTab === '7'" :property="property" />
        </tab-pane>
        <tab-pane title="comments" id="8">
          <span slot="title">
            <i class="fas fa-comments"></i>
            {{ $t("COMMON.COMMENTS") }}
          </span>
          <property-comments 
          v-if="alreadyLoadedTabs.includes('8')"
            v-show="activeTab === '8'"
          :object="property" 
          :canAddComment="true"
          @onCommentsChanged="commentCreated"
          :key="componentKey" />
        </tab-pane>
        <tab-pane title="comments" id="9">
          <span slot="title">
            <i class="fas fa-comments"></i>
            {{ $t("COMMON.SHIPPMENT") }}
          </span>
          <elixio-connect-shipment-manager
            v-if="alreadyLoadedTabs.includes('9')"
            v-show="activeTab === '9'"
            shippable-type="property"
            :shippable-id="property.id"
          />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import PropertyViewGlobal from "../partials/PropertyViewGlobal.vue";
import PropertyViewLogs from "../partials/PropertyViewLogs.vue";
import PropertyViewBids from "../partials/PropertyViewBids.vue";
import PropertyContactListTable from "../partials/PropertyContactListTable.vue";
import PropertyCommunicationListTable from "../partials/PropertyCommunicationListTable.vue";
import PaymentListTable from "../partials/PropertyTransactionListTable.vue";
import PropertyComments from "../partials/PropertyComments.vue";
import PropertyApplicablesFeesListTable from "../partials/PropertyApplicablesFeesListTable.vue";
import ElixioConnectShipmentManager from "@/components/ElixioConnect/ShipmentManager.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  layout: "view-property-component",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    PropertyViewGlobal,
    PropertyViewLogs,
    ListFileComponent,
    PropertyContactListTable,
    PropertyCommunicationListTable,
    PaymentListTable,
    PropertyComments,
    PropertyApplicablesFeesListTable,
    ElixioConnectShipmentManager
    //PropertyViewBids,
  },

  mixins: [],

  props: {
    propertyId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      property: null,
      loading: true,
      componentKey: 0,
      activeTab: '1',
      alreadyLoadedTabs: ['1']
    };
  },

  computed: {},

  watch: {
    activeTab(newTab) {
      if (!this.alreadyLoadedTabs.includes(newTab)) {
        this.alreadyLoadedTabs.push(newTab);
      }
    }
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        this.loading = true;
        if(this.$currentUserCan(this.$permissions.PERM_EDIT_PROPERTIES)){
          //await this.$store.dispatch("properties/assignMrcFees", this.propertyId);
          await this.$store.dispatch("properties/assignMrcFees", {id : this.propertyId});
        }
        await this.$store.dispatch("properties/get", this.propertyId);
        this.property = this.$store.getters["properties/property"];
        this.loading = false;
        this.$emit("propertyChange", this.property);
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    communicationCreated() {
      this.componentKey += 1;
    },
    propertyFeeUpdated() {
      this.componentKey += 1;
    },
    commentCreated() {
      this.componentKey += 1;
    },
    transactionAdded(){
      this.get();
      this.$emit("onTransactionAdded", true);
      this.componentKey += 1;
    },
    async extractPropertyDetails() {
      swal.fire({
        title: `Chargement`,
        onBeforeOpen: () => {
          swal.showLoading();
        },
      });
      try {
        const pdfResponse = await this.$store.dispatch(
          "properties/extractPropertyDetails",
          {id:this.property.id}
        );

        const pdfPath = window.URL.createObjectURL(
          new Blob([pdfResponse.data], { type: "application/pdf" })
        );

        const downloadPdfLink = document.createElement("a");
        downloadPdfLink.href = pdfPath;
        downloadPdfLink.download =
          'propriété-' + this.property.property_number + '-' +
          moment().format("DD/MM/YYYY_HH_mm_ss") +
          ".pdf";

        document.body.appendChild(downloadPdfLink);
        downloadPdfLink.click();
        document.body.removeChild(downloadPdfLink);

        swal.close();
        this.showModal = false;
      } catch (error) {
        console.log('extractPropertyDetails', error);
        swal.close();
        if (error?.response?.status === 404) {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.NO_PROPERTY_FOUND"),
          });
        } else {
          this.$notify({
            type: "danger",
            message: "Oops, something went wrong!",
          });
        }
      }
    },
  },
};
</script>
